/**
 * Smooth scroll to element with navbar offset
 * @param {string} elementId - The ID of the element to scroll to
 * @param {number} offset - Additional offset in pixels (navbar height + padding)
 */
export const smoothScrollToElement = (elementId, offset = 100) => {
  const element = document.getElementById(elementId);
  if (element) {
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
    return true;
  }
  return false;
};

/**
 * Navigate to a page and scroll to a section if provided
 * @param {string} path - The route path
 * @param {string} sectionId - Optional section ID to scroll to
 * @param {Function} navigate - React Router navigate function
 */
export const navigateToSection = (path, sectionId, navigate) => {
  if (sectionId) {
    // If navigating within the same page
    if (window.location.pathname === path) {
      setTimeout(() => smoothScrollToElement(sectionId), 0);
    } else {
      // Navigate to different page, then scroll after navigation
      navigate(path, { state: { scrollToSection: sectionId } });
    }
  } else {
    navigate(path);
  }
};

/**
 * Handle scroll-to-section on page load
 * Call this in a useEffect on the page that might receive navigation state
 */
export const handleScrollToSection = (state) => {
  if (state?.scrollToSection) {
    setTimeout(() => smoothScrollToElement(state.scrollToSection), 100);
  }
};
